import { render, staticRenderFns } from "./Variances.vue?vue&type=template&id=789df7ee&"
import script from "./Variances.vue?vue&type=script&lang=js&"
export * from "./Variances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports